const ITEMS = [
    "Weddings",
    "Vintage piping",
    "Birthday magic",
    "Engagements",
    "Handmade in Colombo",
    "Delivered with love",
];

export default function Marquee() {
    return (
        <div
            data-testid="marquee-band"
            className="relative overflow-hidden border-y border-blush/30 bg-cream-deep py-4 sm:py-5"
        >
            <div className="flex w-max animate-marquee items-center">
                {[0, 1].map((copy) => (
                    <div key={copy} aria-hidden={copy === 1} className="flex items-center">
                        {ITEMS.map((item) => (
                            <span key={`${copy}-${item}`} className="flex items-center">
                                <span className="mx-6 font-serif text-xl italic text-leaf sm:mx-8 sm:text-2xl">
                                    {item}
                                </span>
                                <span
                                    aria-hidden
                                    className="size-1.5 rotate-45 rounded-[1px] bg-gold/80"
                                />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
